(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mystery-discount-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const PREFIX = 'porchia-mystery-';
    const safe = (storage) => ({
      get(key) { try { return JSON.parse(storage.getItem(PREFIX + key)); } catch (e) { return null; } },
      set(key, value) { try { storage.setItem(PREFIX + key, JSON.stringify(value)); } catch (e) {} },
      del(key) { try { storage.removeItem(PREFIX + key); } catch (e) {} }
    });
    const local = safe(window.localStorage);
    const session = safe(window.sessionStorage);

    const toE164 = (dial, raw) => {
      let value = String(raw || '').replace(/[\s().\-]/g, '');
      if (value.startsWith('00')) value = '+' + value.slice(2);
      if (!value.startsWith('+')) value = dial + value.replace(/^0+/, '');
      return /^\+[1-9]\d{6,14}$/.test(value) ? value : null;
    };

    const setup = (root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';

      const card = root.querySelector('.mp__card');
      const pill = root.querySelector('.mp__pill-wrap');
      const pillLabel = root.querySelector('[data-mp-pill-label]');
      const formView = root.querySelector('[data-mp-view="form"]');
      const successView = root.querySelector('[data-mp-view="success"]');
      const form = root.querySelector('form');
      const errors = root.querySelector('[data-mp-errors]');
      const submit = root.querySelector('[data-mp-submit]');
      const dial = root.querySelector('[data-mp-dial]');
      const phone = root.querySelector('[data-mp-phone]');
      const tagsInput = root.querySelector('[data-mp-tags]');
      const baseTags = tagsInput.value;
      const design = root.dataset.designMode === 'true';
      const hideDays = parseInt(root.dataset.hideDays, 10) || 7;

      const show = (state) => {
        card.hidden = state !== 'card';
        pill.hidden = state !== 'pill';
        root.dataset.state = state;
        if (state === 'card') session.set('seen', true);
      };
      const open = (focus) => {
        show('card');
        if (focus) (formView.hidden ? root.querySelector('[data-mp-copy]') : form.querySelector('input:not([type="hidden"])'))?.focus();
      };
      const minimize = () => {
        show('pill');
        if (!design) local.set('state', 'min');
      };
      const dismiss = () => {
        show('none');
        if (!design) {
          local.set('until', Date.now() + hideDays * 86400000);
          local.del('state');
        }
      };

      const renderSuccess = (result, animate) => {
        if (!design) local.set('code', result);
        formView.hidden = true;
        successView.hidden = false;
        root.querySelector('[data-mp-label]').textContent = result.label;
        root.querySelector('[data-mp-code]').textContent = result.code;
        root.querySelector('[data-mp-name]').textContent = result.name ? `, ${result.name}` : '';
        const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        root.querySelector('[data-mp-apply]').href =
          `${base}discount/${encodeURIComponent(result.code)}?redirect=${encodeURIComponent(location.pathname)}`;
        pillLabel.textContent = root.dataset.pillDone || 'Your discount code';
        successView.classList.toggle('is-revealed', !!animate);
      };

      const showError = (message) => {
        errors.textContent = '';
        const line = document.createElement('p');
        line.textContent = message;
        errors.append(line);
        errors.hidden = false;
      };

      const tagsFor = (e164) => (root.dataset.tagPhone === 'true' ? `${baseTags}, phone:${e164}` : baseTags);

      /* Send the form in the background and read the result from the returned page */
      const attempt = async (data) => {
        const response = await fetch(form.getAttribute('action'), {
          method: 'POST',
          body: new URLSearchParams(data),
          credentials: 'same-origin',
          headers: { Accept: 'text/html' }
        });
        if (/\/challenge/.test(response.url)) return { type: 'challenge' };
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const result = doc.querySelector('[data-mp-result]');
        if (result) return { type: 'success', code: result.dataset.code, label: result.dataset.label };
        const err = doc.querySelector('[data-mp] [data-mp-errors]:not([hidden])');
        if (err && err.textContent.trim()) return { type: 'error', message: err.textContent.trim().replace(/\s+/g, ' ') };
        return { type: 'unknown' };
      };

      /* Fallback: a normal page submit (also handles Shopify's bot check) */
      const nativeSubmit = (e164, name) => {
        phone.value = e164;
        tagsInput.value = tagsFor(e164);
        session.set('pending', true);
        session.set('name', name);
        form.submit();
      };

      let busy = false;
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (busy) return;
        errors.hidden = true;

        const name = form.elements['contact[first_name]'].value.trim();
        const email = form.elements['contact[email]'].value.trim();
        const e164 = toE164(dial.value, phone.value);
        if (!name) return showError('Please add your first name.');
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return showError('Please enter a valid email address.');
        if (!e164) return showError('Please enter a valid phone number.');

        if (design) {
          const preview = root.querySelector('[data-mp-preview]');
          return renderSuccess({ code: preview.dataset.code, label: preview.dataset.label, name }, true);
        }

        busy = true;
        submit.disabled = true;
        submit.classList.add('is-loading');
        const data = new FormData(form);
        data.set('contact[phone]', e164);
        data.set('contact[tags]', tagsFor(e164));

        try {
          let result = await attempt(data);
          if (result.type === 'error' && /phone/i.test(result.message)) {
            data.delete('contact[phone]');
            result = await attempt(data);
          }
          if (result.type === 'success') {
            renderSuccess({ code: result.code, label: result.label, name }, true);
          } else if (result.type === 'error') {
            showError(result.message);
          } else {
            nativeSubmit(e164, name);
          }
        } catch (e) {
          nativeSubmit(e164, name);
        } finally {
          busy = false;
          submit.disabled = false;
          submit.classList.remove('is-loading');
        }
      });

      root.querySelector('[data-mp-minimize]').addEventListener('click', minimize);
      root.querySelector('[data-mp-dismiss]').addEventListener('click', dismiss);
      root.querySelector('[data-mp-open]').addEventListener('click', () => {
        if (!design) local.del('state');
        open(true);
      });
      card.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') minimize();
      });

      const copyButton = root.querySelector('[data-mp-copy]');
      copyButton.addEventListener('click', async () => {
        const code = root.querySelector('[data-mp-code]').textContent;
        try {
          await navigator.clipboard.writeText(code);
        } catch (e) {
          const range = document.createRange();
          range.selectNodeContents(root.querySelector('[data-mp-code]'));
          const selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
          document.execCommand('copy');
        }
        copyButton.textContent = 'Copied!';
        setTimeout(() => { copyButton.textContent = 'Copy'; }, 1800);
      });

      root._mysteryPopup = { open, minimize };

      /* Theme editor: preview without saving anything */
      if (design) {
        const preview = root.querySelector('[data-mp-preview]');
        if (root.dataset.previewSuccess === 'true' && preview) {
          renderSuccess({ code: preview.dataset.code, label: preview.dataset.label, name: 'Sienna' }, true);
        }
        show('pill');
        return;
      }

      /* Decide what to show on this page */
      const params = new URLSearchParams(location.search);
      const ours = location.hash === `#${root.dataset.formId}` || session.get('pending');
      const pendingName = session.get('name');
      session.del('pending');
      const serverResult = root.querySelector('[data-mp-result]');
      const saved = local.get('code');
      const hiddenUntil = local.get('until') || 0;

      if (params.get('customer_posted') === 'true' && ours && serverResult) {
        renderSuccess({ code: serverResult.dataset.code, label: serverResult.dataset.label, name: pendingName }, true);
        return open();
      }
      if (ours && !errors.hidden) return open();
      if (saved && saved.code) {
        renderSuccess(saved, false);
        return show(hiddenUntil > Date.now() ? 'none' : 'pill');
      }
      if (root.dataset.subscribed === 'true' || hiddenUntil > Date.now()) return show('none');
      if (root.dataset.mobile !== 'true' && window.matchMedia('(max-width: 749px)').matches) return show('none');
      if (local.get('state') === 'min' || session.get('seen')) return show('pill');

      show('none');
      setTimeout(() => {
        if (root.dataset.state === 'none') open();
      }, (parseInt(root.dataset.delay, 10) || 0) * 1000);
    };

    const init = (scope = document) => scope.querySelectorAll('[data-mp]').forEach(setup);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:select', (event) => {
      event.target.querySelector('[data-mp]')?._mysteryPopup?.open();
    });
    document.addEventListener('shopify:section:deselect', (event) => {
      event.target.querySelector('[data-mp]')?._mysteryPopup?.minimize();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["porchia-girls-instagram"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SRC = 'https://www.instagram.com/embed.js';
    let loader = null;

    const loadEmbeds = () => {
      if (!loader) {
        loader = new Promise((resolve) => {
          if (window.instgrm) return resolve();
          const script = document.createElement('script');
          script.src = SRC;
          script.async = true;
          script.onload = resolve;
          script.onerror = resolve;
          document.body.appendChild(script);
        });
      }
      return loader.then(() => window.instgrm && window.instgrm.Embeds.process());
    };

    /* Shrink each 326px-wide Instagram embed to fit its column */
    const fitEmbeds = (section) => {
      const embeds = section.querySelectorAll('[data-igw-embed]');
      if (!embeds.length) return;
      const fit = () => embeds.forEach((embed) => {
        const space = embed.parentElement.clientWidth;
        if (space) embed.style.zoom = Math.min(1, space / 326).toFixed(4);
      });
      fit();
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(fit);
        embeds.forEach((embed) => observer.observe(embed.parentElement));
      }
    };

    /* Only load Instagram's script when the section is about to scroll into view */
    const setup = (section) => {
      fitEmbeds(section);
      if (!section.querySelector('blockquote.instagram-media')) return;
      if (!('IntersectionObserver' in window)) return loadEmbeds();
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          observer.disconnect();
          loadEmbeds();
        }
      }, { rootMargin: '600px 0px' });
      observer.observe(section);
    };

    const init = (scope = document) => scope.querySelectorAll('[data-igw]').forEach(setup);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-announcement"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const ready = new WeakSet();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const setup = (bar) => {
      if (ready.has(bar)) return;
      ready.add(bar);

      const track = bar.querySelector('.pa-marquee__track');
      const first = track && track.querySelector('.pa-marquee__group');
      if (!first) return;
      const speed = parseFloat(bar.dataset.speed) || 50;

      /* Repeat the messages until they cover the screen, then loop by exactly one set so there's never a gap */
      const fit = () => {
        if (reducedMotion.matches) return;
        const setWidth = first.getBoundingClientRect().width;
        if (!setWidth) return;
        const needed = Math.max(2, Math.ceil(bar.clientWidth / setWidth) + 1);
        for (let count = track.children.length; count < needed; count++) {
          const copy = first.cloneNode(true);
          copy.setAttribute('aria-hidden', 'true');
          copy.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));
          copy.querySelectorAll('[data-shopify-editor-block]').forEach((el) => el.removeAttribute('data-shopify-editor-block'));
          track.appendChild(copy);
        }
        track.style.setProperty('--pa-shift', `-${setWidth}px`);
        track.style.setProperty('--pa-duration', `${(setWidth / speed).toFixed(2)}s`);
      };

      fit();
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(fit);
        observer.observe(bar);
        observer.observe(first);
      }
      if (document.fonts) document.fonts.ready.then(fit);
    };

    const init = (root = document) => root.querySelectorAll('.pa-marquee:not(.pa-marquee--empty)').forEach(setup);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
